import { render } from "./LowStockReport.vue?vue&type=template&id=53fd0923&scoped=true"
import script from "./LowStockReport.vue?vue&type=script&lang=js"
export * from "./LowStockReport.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=53fd0923&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fd0923"]])

export default __exports__